<template>
  <div class="c-banner" :style="{backgroundImage:'url('+ content.img +')'}">
    <div class="c-banner__shadow" v-if="!(content.noShadow == 0)"></div>
    <div class="c-banner__header c-banner__header--type1" v-if='content.type == 1'>
      <h2>{{content.title}}</h2>
      <p>{{content.content}}</p>
    </div>
    <div class="c-banner__header c-banner__header--type2" v-else>
      <p>{{content.content}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bannerGeneral',
    props: ['content'],
    data(){
      return{

      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
